// extracted by mini-css-extract-plugin
var _1 = "InPlaceEditControls-module__animateUploadProgressBarWidth--lICQ5";
var _2 = "InPlaceEditControls-module__animatedBackground--uhXw4";
var _3 = "InPlaceEditControls-module__inPlaceEditControls--M31bH";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "inPlaceEditControls" }
